export const returnValueLenght = (val) => {
  return val?.length;
};

export const validateEmail = (val) => {
  let isValid = false;
  if (val.length) {
    isValid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,9}$/i.test(val);
  }
  return !isValid;
};

/**
 *
 * at least 8 characters
   at least 1 numeric character
  at least 1 lowercase letter
  at least 1 uppercase letter
  at least 1 special character
*/

export const validatePassword = (val) => {
  let isValid = false;
  if (val.length) {
    isValid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/.test(
      val
    );
  }
  return !isValid;
};
